
import { supabase } from "./supabase";
import { Contact, LatLng, SafetyStatus } from "../types";

// Map DB row to Contact interface
const mapProfileToContact = (profile: any): Contact => ({
    id: profile.id,
    name: profile.full_name || 'Unknown Agent',
    role: profile.role || 'AGENT',
    status: (profile.status as SafetyStatus) || SafetyStatus.OFFLINE,
    battery: profile.battery_level || 0,
    locationName: 'Locating...',
    coordinates: {
        lat: profile.location_lat || 0,
        lng: profile.location_lng || 0
    },
    lastSeen: new Date(profile.last_seen).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    avatarUrl: profile.avatar_url || `https://ui-avatars.com/api/?name=${profile.full_name || 'U'}&background=random`,
    phoneNumber: profile.phone_number,
    isTrackable: profile.is_trackable,
    email: profile.email
});

export const fetchSquad = async (): Promise<Contact[]> => {
    try {
        const { data, error } = await supabase
            .from('profiles')
            .select('*')
            .order('last_seen', { ascending: false });

        if (error) {
            // Log warning but don't break app flow, likely empty table or RLS issue initially
            console.warn("Supabase fetch warning:", error.message);
            return [];
        }

        if (data && data.length > 0) {
            return data.map(mapProfileToContact);
        }

        return [];
    } catch (e) {
        console.warn("Unexpected error in fetchSquad:", e);
        return [];
    }
};

export const updateMyLocation = async (lat: number, lng: number, battery: number) => {
    try {
        // Use custom auth user ID from localStorage (not Supabase Auth)
        const userId = localStorage.getItem('squad_id');
        if (!userId) {
            console.warn('⚠️ No squad_id in localStorage - cannot update location');
            return;
        }

        // Use UPDATE instead of UPSERT to avoid requiring all columns
        const { data, error } = await supabase
            .from('profiles')
            .update({
                location_lat: lat,
                location_lng: lng,
                updated_at: new Date().toISOString()
            })
            .eq('id', userId)
            .select();

        if (error) {
            console.error('❌ Location update failed:', error.message);
            return;
        }

        if (data && data.length > 0) {
            console.log(`📍 Location saved: ${lat.toFixed(6)}, ${lng.toFixed(6)}`);
        } else {
            console.warn('⚠️ No profile found for user:', userId);
        }
    } catch (e) {
        console.error("❌ Location update error:", e);
    }
};

export const updateMyStatus = async (status: SafetyStatus) => {
    try {
        // Use custom auth user ID from localStorage
        const userId = localStorage.getItem('squad_id');
        if (!userId) return;
        await supabase.from('profiles').update({ status }).eq('id', userId);
    } catch (e) {
        console.warn("Failed to update status:", e);
    }
};

